/* tslint:disable */
/* eslint-disable */
/**
 * Open Api
 * Open Endpoints <b>Build:</b>Radianse.Api.Identity_main_2023.9.11.1
 *
 * The version of the OpenAPI document: OpenApi
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 *
 * @export
 * @interface IGetClientTokenVm
 */
export interface IGetClientTokenVm {
  /**
   * Client ID
   * @type {string}
   * @memberof IGetClientTokenVm
   */
  clientId: string;
  /**
   * Client secret
   * @type {string}
   * @memberof IGetClientTokenVm
   */
  clientSecret: string;
}
/**
 *
 * @export
 * @interface IGetTokenResponse
 */
export interface IGetTokenResponse {
  /**
   *
   * @type {string}
   * @memberof IGetTokenResponse
   */
  error?: string | null;
  /**
   *
   * @type {string}
   * @memberof IGetTokenResponse
   */
  expirationDate?: string;
  /**
   *
   * @type {number}
   * @memberof IGetTokenResponse
   */
  expiresInSeconds?: number;
  /**
   *
   * @type {string}
   * @memberof IGetTokenResponse
   */
  token: string;
}
/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 *
 * @export
 * @interface IIRadianseRequestContextRadianseResult
 */
export interface IIRadianseRequestContextRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IIRadianseRequestContext}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  data?: IIRadianseRequestContext;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  timeStamp?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContextRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IProblemDetails
 */
export interface IProblemDetails {
  [key: string]: any;

  /**
   *
   * @type {string}
   * @memberof IProblemDetails
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProblemDetails
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof IProblemDetails
   */
  status?: number | null;
  /**
   *
   * @type {string}
   * @memberof IProblemDetails
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof IProblemDetails
   */
  instance?: string | null;
}

/**
 * RequestContextApi - axios parameter creator
 * @export
 */
export const RequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    openApiRequestContextGet: async (
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/OpenApi/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequestContextApi - functional programming interface
 * @export
 */
export const RequestContextApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async openApiRequestContextGet(
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContextRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.openApiRequestContextGet(
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RequestContextApi - factory interface
 * @export
 */
export const RequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequestContextApiFp(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    openApiRequestContextGet(
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContextRadianseResult> {
      return localVarFp
        .openApiRequestContextGet(acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequestContextApi - object-oriented interface
 * @export
 * @class RequestContextApi
 * @extends {BaseAPI}
 */
export class RequestContextApi extends BaseAPI {
  /**
   *
   * @summary
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public openApiRequestContextGet(
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .openApiRequestContextGet(acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get a token
     * @param {string} [acceptLanguage]
     * @param {IGetClientTokenVm} [iGetClientTokenVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceClientToken: async (
      acceptLanguage?: string,
      iGetClientTokenVm?: IGetClientTokenVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/OpenApi/Token`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iGetClientTokenVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TokenApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get a token
     * @param {string} [acceptLanguage]
     * @param {IGetClientTokenVm} [iGetClientTokenVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getServiceClientToken(
      acceptLanguage?: string,
      iGetClientTokenVm?: IGetClientTokenVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IGetTokenResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getServiceClientToken(
          acceptLanguage,
          iGetClientTokenVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TokenApiFp(configuration);
  return {
    /**
     *
     * @summary Get a token
     * @param {string} [acceptLanguage]
     * @param {IGetClientTokenVm} [iGetClientTokenVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceClientToken(
      acceptLanguage?: string,
      iGetClientTokenVm?: IGetClientTokenVm,
      options?: any
    ): AxiosPromise<IGetTokenResponse> {
      return localVarFp
        .getServiceClientToken(acceptLanguage, iGetClientTokenVm, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI {
  /**
   *
   * @summary Get a token
   * @param {string} [acceptLanguage]
   * @param {IGetClientTokenVm} [iGetClientTokenVm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TokenApi
   */
  public getServiceClientToken(
    acceptLanguage?: string,
    iGetClientTokenVm?: IGetClientTokenVm,
    options?: AxiosRequestConfig
  ) {
    return TokenApiFp(this.configuration)
      .getServiceClientToken(acceptLanguage, iGetClientTokenVm, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
